import {
  QA_NAME_GRETA_AI_CHAT_PROJECT_MENU_DELETE,
  QA_NAME_GRETA_AI_CHAT_PROJECT_MENU_RENAME,
} from './GretaAIChatProjectMenu.constants'

import DeleteIcon from '../../../icons/delete.svg'
import EditIcon from '../../../icons/edit.svg'

export function getGretaAIChatProjectMenuItems({ t, onDelete, onRename }) {
  return [
    {
      Icon: EditIcon,
      qaName: QA_NAME_GRETA_AI_CHAT_PROJECT_MENU_RENAME,
      text: t('Greta.RenameProjectActionKey'),
      onClick: onRename,
    },
    {
      Icon: DeleteIcon,
      qaName: QA_NAME_GRETA_AI_CHAT_PROJECT_MENU_DELETE,
      text: t('Greta.DeleteProjectActionKey'),
      onClick: onDelete,
    },
  ]
}
